import classNames from "classnames/dedupe";
import React from "react";
import { IDropdownButtonTextProps } from "../../../ActionsSelectors/Select";

export function QtyButtonContent<Option, IsMulti>({
  classes,
  hasSelectedValue,
  placeholder = "",
  selected,
  multiple,
  titlePrefix,
  labelKey,
}: IDropdownButtonTextProps<Option, IsMulti>) {
  return hasSelectedValue ? (
    <div
      data-testid="QtyButtonContent"
      className={classNames("text-small", classes?.root)}
    >
      {titlePrefix}{" "}
      <span className="text-small-bold" data-testid="QtyButtonContent__amount">
        {multiple && Array.isArray(selected)
          ? selected.map((item) => item[labelKey]).join(", ")
          : ((selected as Option)[labelKey] as string)}
      </span>
    </div>
  ) : (
    <>{placeholder}</>
  );
}
